<template>
  <div id="drawCanvas"></div>
</template>

<script>
import Konva from "konva";
import _ from "lodash";
export default {
  data: function () {
    return {
      stage: null,
      baseLayer: null,
      triangleLayer: null,
      triangleLeftLayer: null,
      triangleRightLayer: null,
      maxWidth: 0,
      maxHeight: 0,
      drawAreaWidth: 0,
      drawAreaHeight: 0,
      squareUnit: 0,
      margin: 20,
      p1: null,
      p2: null,
      leftTriangleAnimation: null,
      rightTriangleAnimation: null,
    };
  },
  props: ["initP1", "initP2", "checking"],
  watch: {
    initP1() {
      // Reset the canvas.
      this.clearAnimation();
      this.triangleLayer.destroy();
      this.triangleLeftLayer.destroy();
      this.triangleRightLayer.destroy();
      this.drawTriangle();
    },
    checking(value) {
      if (value === true) {
        // console.log("run animation");
        this.drawSplitTriangle();
      }
    },
  },
  methods: {
    initStage() {
      this.maxWidth = document.getElementById("drawCanvas").offsetWidth;
      this.drawAreaWidth = this.maxWidth - this.margin * 2;
      this.squareUnit = this.drawAreaWidth / 20;
      this.drawAreaHeight = this.squareUnit * 10;
      this.maxHeight = this.drawAreaHeight + this.margin * 2;
      this.stage = new Konva.Stage({
        container: "drawCanvas",
        width: this.maxWidth,
        height: this.maxHeight,
      });
    },
    drawGrid() {
      this.baseLayer = new Konva.Layer();
      for (let i = 0; i <= 10; i++) {
        // horizontal line
        let hLine = new Konva.Line({
          points: [
            this.squareUnit * 5,
            this.squareUnit * i + this.margin,
            this.squareUnit * 20,
            this.squareUnit * i + this.margin,
          ],
          stroke: "#77DAE6",
          strokeWidth: 1,
        });

        // Numbers(0 - 10) on Y axis
        let hNum = new Konva.Text({
          x: this.squareUnit * 5 - this.squareUnit * 0.8,
          y: this.squareUnit * i + this.margin * 0.7,
          text: 10 - i,
          fontSize: 15,
          fontFamily: "Verdana",
          fill: "rgba(50, 120, 255, 1)",
        });

        this.baseLayer.add(hLine);
        this.baseLayer.add(hNum);
      }
      for (let j = 0; j <= 15; j++) {
        // vertical line
        let vLine = new Konva.Line({
          points: [
            this.squareUnit * (j + 5),
            this.margin,
            this.squareUnit * (j + 5),
            this.squareUnit * 10 + this.margin,
          ],
          stroke: "#77DAE6",
          strokeWidth: 1,
        });
        // Numbers(1 - 15) on X axis
        if (j > 0) {
          let vNum = new Konva.Text({
            x: this.squareUnit * (j + 5) - this.squareUnit * 0.2,
            y: this.squareUnit * 10 + this.margin * 1.2,
            text: j,
            fontSize: 15,
            fontFamily: "Verdana",
            fill: "rgba(50, 120, 255, 1)",
          });
          this.baseLayer.add(vNum);
        }
        this.baseLayer.add(vLine);
      }
      this.stage.add(this.baseLayer);
    },
    drawTriangle() {
      this.triangleLayer = new Konva.Layer();
      let self = this;
      const { canvasX: x0, canvasY: y0 } = this.cartesianToCanvas(0, 0);
      const { canvasX: x1, canvasY: y1 } = this.cartesianToCanvas(
        this.p1.x,
        this.p1.y
      );
      const { canvasX: x2, canvasY: y2 } = this.cartesianToCanvas(
        this.p2.x,
        this.p2.y
      );
      let triangle = new Konva.Line({
        points: [x0, y0, x1, y1, x2, y2, x0, y0],
        stroke: "#000",
        strokeWidth: 1,
        closed: true,
        fill: "rgba(245, 180, 50, 0.4)",
      });
      // const squareUnit = this.squareUnit;
      // const margin = this.margin;
      let newX1 = x1,
        newY1 = y1,
        newX2 = x2,
        newY2 = y2;
      const circle1 = new Konva.Circle({
        x: x1,
        y: y1,
        radius: this.squareUnit * 0.4,
        fill: "rgba(230, 0, 0, 0.15)",
        stroke: "rgba(230, 0, 0, 1)",
        draggable: true,
        dragBoundFunc: function (pos) {
          // console.log(newX2);
          let rightBoundary = Math.min(
            self.squareUnit * 20,
            (newX2 - self.squareUnit * 5) * 2 + self.squareUnit * 5
          );
          newX1 =
            pos.x < self.squareUnit * 5
              ? self.squareUnit * 5
              : pos.x > rightBoundary
              ? rightBoundary
              : pos.x;
          newY1 =
            pos.y < self.margin
              ? self.margin
              : pos.y > self.margin + self.squareUnit * 9
              ? self.margin + self.squareUnit * 9
              : pos.y;
          triangle.destroy();
          triangle = new Konva.Line({
            points: [x0, y0, newX1, newY1, newX2, newY2, x0, y0],
            stroke: "#000",
            strokeWidth: 1,
            closed: true,
            fill: "rgba(245, 180, 50, 0.4)",
          });
          self.triangleLayer.add(triangle);
          self.$emit("newPos", {
            newPos: [newX1, newY1, newX2, newY2],
            margin: self.margin,
            squareUnit: self.squareUnit,
          });
          return {
            x: newX1,
            y: newY1,
          };
        },
      });

      const circle2 = new Konva.Circle({
        x: x2,
        y: y2,
        radius: this.squareUnit * 0.4,
        fill: "rgba(230, 0, 0, 0.15)",
        stroke: "rgba(230, 0, 0, 1)",
        draggable: true,
        dragBoundFunc: function (pos) {
          let leftBoundary = Math.max(
            (newX1 - self.squareUnit * 5) / 2 + self.squareUnit * 5,
            self.squareUnit * 6
          );
          newY2 = this.absolutePosition().y;
          newX2 =
            pos.x < leftBoundary
              ? leftBoundary
              : pos.x > self.squareUnit * 15
              ? self.squareUnit * 15
              : pos.x;
          triangle.destroy();
          triangle = new Konva.Line({
            points: [x0, y0, newX1, newY1, newX2, newY2, x0, y0],
            stroke: "#000",
            strokeWidth: 1,
            closed: true,
            fill: "rgba(245, 180, 50, 0.4)",
          });
          self.triangleLayer.add(triangle);
          self.$emit("newPos", {
            newPos: [newX1, newY1, newX2, newY2],
            margin: self.margin,
            squareUnit: self.squareUnit,
          });
          return {
            x: newX2,
            y: newY2,
          };
        },
      });
      this.triangleLayer.add(triangle);
      this.triangleLayer.add(circle1);
      this.triangleLayer.add(circle2);
      this.stage.add(this.triangleLayer);
    },

    /** Split the triangle into three parts */
    drawSplitTriangle() {
      const p0 = { x: 0, y: 0 };
      const p1 = _.cloneDeep(this.initP1);
      const p2 = _.cloneDeep(this.initP2);
      this.triangleLayer.destroy();
      if (p2.x >= p1.x) {
        // 分割一个锐角三角形
        const m1 = { x: p1.x / 2, y: p1.y / 2 };
        const m2 = { x: (p2.x - p1.x) / 2 + p1.x, y: p1.y / 2 };
        const m3 = { x: p1.x, y: p1.y / 2 };
        const { canvasX: m1X, canvasY: m1Y } = this.cartesianToCanvas(
          m1.x,
          m1.y
        );
        const { canvasX: m2X, canvasY: m2Y } = this.cartesianToCanvas(
          m2.x,
          m2.y
        );
        const { canvasX: m3X, canvasY: m3Y } = this.cartesianToCanvas(
          m3.x,
          m3.y
        );
        const { canvasX: p0X, canvasY: p0Y } = this.cartesianToCanvas(
          p0.x,
          p0.y
        );
        const { canvasX: p1X, canvasY: p1Y } = this.cartesianToCanvas(
          p1.x,
          p1.y
        );
        const { canvasX: p2X, canvasY: p2Y } = this.cartesianToCanvas(
          p2.x,
          p2.y
        );
        const base = new Konva.Line({
          points: [p0X, p0Y, m1X, m1Y, m2X, m2Y, p2X, p2Y, p0X, p0Y],
          stroke: "#000",
          strokeWidth: 1,
          closed: true,
          fill: "rgba(245,180,50, 0.4)",
        });
        const triangleLeft = new Konva.Line({
          points: [m1X, m1Y, p1X, p1Y, m3X, m3Y, m1X, m1Y],
          stroke: "#000",
          strokeWidth: 1,
          closed: true,
          fill: "rgba(245,180,50, 0.4)",
          offset: {
            x: m1X,
            y: m1Y,
          },
        });
        const triangleRight = new Konva.Line({
          points: [m3X, m3Y, p1X, p1Y, m2X, m2Y, m3X, m3Y],
          stroke: "#000",
          strokeWidth: 1,
          closed: true,
          fill: "rgba(245,180,50, 0.4)",
          offset: {
            x: m2X,
            y: m2Y,
          },
        });
        this.triangleLayer.add(base);
        this.triangleLeftLayer = new Konva.Layer({
          offsetX: -m1X,
          offsetY: -m1Y,
        });
        this.triangleRightLayer = new Konva.Layer({
          offsetX: -m2X,
          offsetY: -m2Y,
        });
        this.triangleLeftLayer.add(triangleLeft);
        this.triangleRightLayer.add(triangleRight);
        this.stage.add(this.triangleLayer);
        this.stage.add(this.triangleLeftLayer);
        this.stage.add(this.triangleRightLayer);

        // Animation
        let leftAngleAcc = 0;
        let rightAngleAcc = 0;

        this.rightTriangleAnimation = new Konva.Animation(() => {
          let angleDiff = 1;
          if (rightAngleAcc >= 180) {
            this.rightTriangleAnimation.stop();
            this.$emit("animationFinish", true);
          } else {
            triangleRight.rotate(angleDiff);
          }
          rightAngleAcc += angleDiff;
        }, this.triangleRightLayer);

        this.leftTriangleAnimation = new Konva.Animation(() => {
          let angleDiff = -1;
          if (leftAngleAcc <= -180) {
            this.leftTriangleAnimation.stop();

            this.rightTriangleAnimation.start();
          } else {
            triangleLeft.rotate(angleDiff);
          }
          leftAngleAcc += angleDiff;
        }, this.triangleLeftLayer);
        this.leftTriangleAnimation.start();
      }

      if (p2.x < p1.x) {
        // 分割一个钝角三角形
        const m1 = { x: p1.x / 2, y: p1.y / 2 };
        const m2 = { x: (p1.x - p2.x) / 2 + p2.x, y: p1.y / 2 };
        const m3 = { x: p2.x, y: p1.y / 2 };
        const { canvasX: m1X, canvasY: m1Y } = this.cartesianToCanvas(
          m1.x,
          m1.y
        );
        const { canvasX: m2X, canvasY: m2Y } = this.cartesianToCanvas(
          m2.x,
          m2.y
        );
        const { canvasX: m3X, canvasY: m3Y } = this.cartesianToCanvas(
          m3.x,
          m3.y
        );
        const { canvasX: p0X, canvasY: p0Y } = this.cartesianToCanvas(
          p0.x,
          p0.y
        );
        const { canvasX: p1X, canvasY: p1Y } = this.cartesianToCanvas(
          p1.x,
          p1.y
        );
        const { canvasX: p2X, canvasY: p2Y } = this.cartesianToCanvas(
          p2.x,
          p2.y
        );
        const base = new Konva.Line({
          points: [p0X, p0Y, m1X, m1Y, m3X, m3Y, p2X, p2Y, p0X, p0Y],
          stroke: "#000",
          strokeWidth: 1,
          closed: true,
          fill: "rgba(245,180,50, 0.4)",
        });
        const triangleLeft = new Konva.Line({
          points: [m1X, m1Y, p1X, p1Y, m2X, m2Y, m1X, m1Y],
          stroke: "#000",
          strokeWidth: 1,
          closed: true,
          fill: "rgba(245,180,50, 0.4)",
          offset: {
            x: m1X,
            y: m1Y,
          },
        });
        const triangleRight = new Konva.Line({
          points: [m3X, m3Y, p2X, p2Y, m2X, m2Y, m3X, m3Y],
          stroke: "#000",
          strokeWidth: 1,
          closed: true,
          fill: "rgba(245,180,50, 0.4)",
        });
        this.triangleLayer.add(base);
        this.triangleLeftLayer = new Konva.Layer({
          offset: {
            x: -m1X,
            y: -m1Y,
          },
        });
        this.triangleRightLayer = new Konva.Layer();
        this.triangleLeftLayer.add(triangleLeft);
        this.triangleRightLayer.add(triangleRight);
        this.stage.add(this.triangleLayer);
        this.stage.add(this.triangleLeftLayer);
        this.stage.add(this.triangleRightLayer);

        // Animation
        let posX = triangleRight.getAttr("x");
        this.rightTriangleAnimation = new Konva.Animation((frame) => {
          let diff = (frame.timeDiff * 80) / 1000;
          posX -= diff;
          // console.log(posX);
          // console.log(m3X);
          // triangleRight.x(posX);
          if (posX <= -(p2X - p0X)) {
            this.rightTriangleAnimation.stop();
            this.$emit("animationFinish", true);
          } else {
            triangleRight.x(posX);
          }
        }, this.triangleRightLayer);

        let angleAcc = 0;
        this.leftTriangleAnimation = new Konva.Animation(() => {
          let angleDiff = -1;
          if (angleAcc <= -180) {
            this.leftTriangleAnimation.stop();
            this.rightTriangleAnimation.start();
          } else {
            triangleLeft.rotate(angleDiff);
          }
          angleAcc += angleDiff;
        }, this.triangleLeftLayer);
        this.leftTriangleAnimation.start();
      }
    },
    initDraw() {
      this.drawGrid();
      this.drawTriangle();
    },

    clearAnimation() {
      if (this.leftTriangleAnimation) {
        this.leftTriangleAnimation.stop();
      }
      if (this.rightTriangleAnimation) {
        this.rightTriangleAnimation.stop();
      }
    },

    cartesianToCanvas(x, y) {
      return {
        canvasX: this.squareUnit * (x + 5),
        canvasY: this.margin + this.squareUnit * (10 - y),
      };
    },

    canvasToCartesian(canvasX, canvasY) {
      return {
        x: canvasX / this.squareUnit - 5,
        y: 10 - canvasY - this.margin / this.squareUnit,
      };
    },
  },
  created() {
    this.p1 = _.cloneDeep(this.initP1);
    this.p2 = _.cloneDeep(this.initP2);
  },
  mounted() {
    this.initStage();
    this.initDraw();
  },
};
</script>

<style scoped>
</style>